module.exports = __webpack_public_path__ + "img/logo-dark.952c0c34.svg";